import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e31b35cc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e31b35cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31b35cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e31b35cc')) {
      api.createRecord('e31b35cc', component.options)
    } else {
      api.reload('e31b35cc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e31b35cc&scoped=true&", function () {
      api.rerender('e31b35cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-81wW50y6v8Ddq/JS/comp/GuestBox.vue"
export default component.exports